import Grid from "@mui/material/Grid";
import FormController from "../formController/FormController";
import CBFormTextFieldController from "../formController/CBFormTextFieldController";
import { useRecoilValue } from "recoil";
import { isGlobalEditModeState, isMobilityVoucherModeState, sapEnumState } from "../../state/customerbaseState";
import { CBCreationOfProps, IFormValues } from "../../types";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CBPaymentProps extends CBCreationOfProps {
    index: number
}

const CBPayment = ({
    index,
    creationOf
}: CBPaymentProps) => {

    const isCreationMode = !!creationOf;
    const { t } = useTranslation("customerbase")
    
    const { trigger }  = useFormContext<IFormValues>();

    const isMobilityVoucherMode = useRecoilValue(isMobilityVoucherModeState);
    const editing = useRecoilValue(isGlobalEditModeState);
    const sapEnum = useRecoilValue(sapEnumState);

    return (
        <Grid container columnSpacing={3} rowSpacing={1}>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbPaymentInfo.${index}.buagClass`} 
                    label={"buagClass"} 
                    options={sapEnum.buagClass || []}
                    showSelect={isCreationMode || editing}                                          
                />
            </Grid>
            <Grid item md={6} xs={12}/>
            <Grid item md={6} xs={12}>
                <CBFormTextFieldController 
                    formName={`cbPaymentInfo.${index}.iban`}
                    idField={`iban-${index}`}
                    label={"iban"} 
                    readOnly={isCreationMode ? false : !editing}
                    inputProps={{maxLength: 34, style: {textTransform: "uppercase"}}}

                />
            </Grid>
            <Grid item md={6} xs={12}>
                <CBFormTextFieldController 
                    formName={`cbPaymentInfo.${index}.accountHolder`}
                    idField={`accountHolder-${index}`}
                    label={"accountHolder"} 
                    readOnly={isCreationMode ? false : !editing}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <CBFormTextFieldController 
                    formName={`cbPaymentInfo.${index}.referenceDetails`}
                    idField={`referenceDetails-${index}`}
                    label={"referenceDetails"} 
                    readOnly={isCreationMode ? false : !editing}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbPaymentInfo.${index}.paymentMethod`} 
                    label={"paymentMethod"} 
                    options={sapEnum.paymentMethods || []}
                    showSelect={isCreationMode || editing}
                    handleAdditionalBehaviourOnChange={(_value) => {
                        trigger(`cbPaymentInfo.${index}.iban`);
                    }}
                    isMandatory={isMobilityVoucherMode}                                               
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbPaymentInfo.${index}.paymentTerms`} 
                    label={"paymentTerms"} 
                    options={sapEnum.paymentTerms || []}
                    showSelect={isCreationMode || editing}
                    isMandatory={isMobilityVoucherMode}                                                
                    getOptionLabel={(opt: any) => opt.value && t(`sapEnum.paymentTerms.${opt.value}`)}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbPaymentInfo.${index}.correspondingVariant`} 
                    label={"correspondingVariant"} 
                    options={sapEnum.correspondingVariants || []}
                    showSelect={isCreationMode || editing}
                    isMandatory={isMobilityVoucherMode}                                                
                />
            </Grid>
        </Grid>
    )

}

export default CBPayment;